"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var classes = require('./ExchangePage.module.css');

var ExchangePage =
/** @class */
function (_super) {
  __extends(ExchangePage, _super);

  function ExchangePage(props) {
    var _this = _super.call(this, props) || this;

    _this.exchange = props.plugin;

    var firstPair = _this.exchange.getPairs()[0];

    _this.state = {
      assetA: _this.exchange.getAsset(firstPair.assetA),
      assetB: _this.exchange.getAsset(firstPair.assetB),
      amount: '',
      isExchanging: false
    };
    return _this;
  }

  ExchangePage.prototype.runExchange = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a, assetA, assetB, amount, account, pair, exchangeProps, response, e_1;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.state, assetA = _a.assetA, assetB = _a.assetB, amount = _a.amount;
            account = this.props.accounts[0];
            pair = this.exchange.getPairs().filter(function (_pair) {
              return _pair.assetA === assetA.id && _pair.assetB === assetB.id || _pair.assetA === assetB.id && _pair.assetB === assetA.id;
            })[0];

            if (!pair) {
              throw new Error('Invalid pair');
            }

            exchangeProps = {
              account: account,
              ether: amount
            };
            this.setState({
              isExchanging: true
            });
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , pair.assetA === assetA.id ? pair.exchangeAtoB(exchangeProps) : pair.exchangeBtoA(exchangeProps)];

          case 2:
            response = _b.sent();
            return [3
            /*break*/
            , 4];

          case 3:
            e_1 = _b.sent();
            console.error(e_1);
            return [3
            /*break*/
            , 4];

          case 4:
            this.setState({
              isExchanging: false
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ExchangePage.prototype.getPairOptions = function (asset) {
    var pairs = this.exchange.getPairs();
    var options = [];

    for (var _i = 0, pairs_1 = pairs; _i < pairs_1.length; _i++) {
      var pair = pairs_1[_i];

      if (pair.assetA === asset.id) {
        options.push(this.exchange.getAsset(pair.assetB));
      }

      if (pair.assetB === asset.id) {
        options.push(this.exchange.getAsset(pair.assetA));
      }
    }

    return options;
  };

  ExchangePage.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        burnerComponents = _a.burnerComponents,
        assets = _a.assets,
        accounts = _a.accounts;
    var _b = this.state,
        assetA = _b.assetA,
        assetB = _b.assetB,
        amount = _b.amount,
        isExchanging = _b.isExchanging;
    var Page = burnerComponents.Page,
        AssetSelector = burnerComponents.AssetSelector,
        Button = burnerComponents.Button,
        AmountInput = burnerComponents.AmountInput;

    if (accounts.length === 0) {
      return null;
    }

    var account = accounts[0];
    var assetBOptions = this.getPairOptions(assetA);
    var assetsProps = {
      assets: assetBOptions
    };
    return react_1.default.createElement(Page, {
      title: "Exchange"
    }, react_1.default.createElement("div", {
      className: classes.fromContainer
    }, react_1.default.createElement("div", null, "From:"), react_1.default.createElement(AssetSelector, {
      selected: assetA,
      onChange: function onChange(newAsset) {
        _this.setState({
          assetA: newAsset
        });

        var options = _this.getPairOptions(newAsset);

        if (options.length > 0 && options.indexOf(assetB) === -1) {
          _this.setState({
            assetB: options[0]
          });
        }
      },
      disabled: isExchanging
    }), react_1.default.createElement(AmountInput, {
      asset: assetA,
      value: amount,
      onChange: function onChange(e) {
        return _this.setState({
          amount: e.target.value
        });
      },
      disabled: isExchanging
    })), assetBOptions.length > 0 ? react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement("div", null, "To:"), react_1.default.createElement(AssetSelector, __assign({
      selected: assetB,
      onChange: function onChange(newAsset) {
        return _this.setState({
          assetB: newAsset
        });
      },
      disabled: isExchanging
    }, assetsProps))) : react_1.default.createElement("div", null, "No exchanges available for ", assetA.name), react_1.default.createElement(Button, {
      onClick: function onClick() {
        return _this.runExchange();
      },
      disabled: isExchanging || assetBOptions.length === 0
    }, "Exchange"));
  };

  return ExchangePage;
}(react_1.Component);

exports.default = ExchangePage;